import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// A fleet-manager page gated by one page-access permission. Without it, go to the
// live map when that is allowed (login lands on /trucks, so a map-only account must
// not bounce past it), otherwise to the dashboard, which has no permission of its own.
export default function PermissionRoute({ permission, children }) {
  const { hasPermission } = useAuth();
  if (hasPermission(permission)) return children;
  return <Navigate to={hasPermission('fm_live_status') ? '/live-status' : '/'} replace />;
}
